import * as React from 'react';
import './v2MigrationNotice.module.scss';
import { DetailedDate } from '@sheinc/design-system';

export const V2MigrationNotice = ({ freeTrialMonths, paymentStartsAt }) => (
  <div styleName="notice">
    <div styleName="header">※新プラン移行割引について</div>
    <div styleName="body">
      ・選択したプランの{freeTrialMonths}ヶ月分を今回無料で適用します
      <br />
       ・適用期間が終了すると選択したプランで自動更新が行われます
      <br />
       ・適用開始時期 <DetailedDate date={paymentStartsAt} />〜
    </div>
  </div>
);
